import React from 'react';
import styled from 'styled-components';

import JsonLogicBuilder from '../JsonLogicBuilder';

function JsonLogicInput({label, value, variables, onChange, helpText, invalid, validationText}) {
  return (
    <>
      <Label>{label}</Label>
      <Container invalid={invalid}>
        <JsonLogicBuilder expand variables={variables} value={value} onChange={onChange} />
      </Container>
      {((invalid && validationText) || helpText) && (
        <Help invalid={invalid ? true : undefined}>{invalid ? validationText : helpText}</Help>
      )}
    </>
  );
}

const Label = styled.p`
  display: block;
  margin: 0 0 0.5rem 0;
`;

const Container = styled.div`
  padding: 1rem;
  border: 1px solid ${props => props.invalid ? '#dc3545' : '#E0E5EA'};
  background: #F5F5F5;
  overflow-y: hidden;
  overflow-x: auto;
  border-radius: 0.25rem;
  white-space: nowrap;
`;

const Help = styled.small`
  display: block;
  font-size: 0.875rem;
  color: #747474;
  margin-top: 0.5rem;

  ${props => {
    if (props.invalid) {
      return `
        color: #dc3545;
      `;
    }
  }}
`;

export default JsonLogicInput;